import { RoleId } from '@snapaddy/snapaddy-types/common';
export class RoleFilter {
    selectedRoleIds = [];
    display = { type: 'all' };
    groups = [
        {
            roles: [
                {
                    id: RoleId.ADMIN,
                    translationKey: 'ROLES.ADMIN',
                    selected: false,
                    elevated: true,
                },
            ],
        },
        {
            label: 'VisitReport',
            roles: [
                { id: RoleId.REPORTER, translationKey: 'ROLES.REPORTER', selected: false },
                {
                    id: RoleId.VR_USER,
                    translationKey: 'ROLES.VR_USER',
                    selected: false,
                },
                {
                    id: RoleId.VR_EVENT_MANAGER,
                    translationKey: 'ROLES.EVENT_MANAGER',
                    selected: false,
                    elevated: true,
                },
                {
                    id: RoleId.VR_TEMPLATE_CURATOR,
                    translationKey: 'ROLES.EVENT_CURATOR',
                    selected: false,
                    elevated: true,
                },
            ],
        },
        {
            label: 'BusinessCards',
            roles: [
                {
                    id: RoleId.BC_USER,
                    translationKey: 'ROLES.BC_USER',
                    selected: false,
                },
                {
                    id: RoleId.BC_MANAGER,
                    translationKey: 'ROLES.BC_MANAGER',
                    selected: false,
                    elevated: true,
                },
            ],
        },
        {
            label: 'DataAgents',
            roles: [
                {
                    id: RoleId.DA_USER,
                    translationKey: 'ROLES.DA_USER',
                    selected: false,
                },
                {
                    id: RoleId.DA_MANAGER,
                    translationKey: 'ROLES.DA_MANAGER',
                    selected: false,
                    elevated: true,
                },
            ],
        },
        {
            label: 'LeadResearch',
            roles: [
                {
                    id: RoleId.LR_USER,
                    translationKey: 'ROLES.LR_USER',
                    selected: false,
                },
            ],
        },
    ];
    roles = this.groups.flatMap((group) => group.roles);
    elevatedRoles = this.roles.filter((role) => role.elevated);
    updateSelection() {
        const selectedRoles = this.roles.filter((role) => role.selected);
        const allRolesSelected = selectedRoles.length === this.roles.length;
        const hasActiveFilter = selectedRoles.length > 0 && !allRolesSelected;
        this.selectedRoleIds = hasActiveFilter ? selectedRoles.map((role) => role.id) : [];
        const elevatedRolesSelected = selectedRoles.length === this.elevatedRoles.length && this.elevatedRoles.every((role) => role.selected);
        if (!hasActiveFilter) {
            this.display = { type: 'all' };
        }
        else if (elevatedRolesSelected) {
            this.display = { type: 'elevated' };
        }
        else if (selectedRoles.length === 1) {
            this.display = {
                type: 'single',
                translationKey: selectedRoles[0].translationKey,
            };
        }
        else {
            this.display = { type: 'multiple', count: selectedRoles.length };
        }
    }
    selectAll() {
        for (const role of this.roles) {
            role.selected = true;
        }
        this.updateSelection();
    }
    selectElevated() {
        for (const role of this.roles) {
            role.selected = role.elevated === true;
        }
        this.updateSelection();
    }
    clearSelection() {
        for (const role of this.roles) {
            role.selected = false;
        }
        this.updateSelection();
    }
    selectRoleIds(roleIds) {
        const selectedRoleIds = new Set(roleIds);
        for (const role of this.roles) {
            role.selected = selectedRoleIds.has(role.id);
        }
        this.updateSelection();
    }
}
